import permission from './permission';
import scroll from './scroll';

export default [
    permission,
    scroll
];
